import { React, ui, dtos, observable, observer, selectFilter, serviceClient, shared, splitIntoWords, makeObservable } from "../common";
import AutoFocus from "../autofocus";
import ValueEditor from "../flows/value-editor";
import AutoComplete from "../autocomplete";
import CustomersList from "./customers-list";

interface Props {
    visible: boolean;
    onClosed: () => void;
    onCreated: (alert: dtos.AlertInfo) => void;
}

@observer
export default class NewAlert extends React.Component<Props> {
    @observable name = "";
    @observable trigger: dtos.AlertTriggers = dtos.AlertTriggers.CallSpend;
    @observable threshold = 25;
    @observable windowHours = 1;
    @observable notificationEmailAddresses = "";
    @observable customerSelection = dtos.AlertCustomerSelection.AllCustomers;
    @observable customerIds: string[] = [];

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    async componentDidMount() {
    }

    async save(ev: React.FormEvent) {
        ev.preventDefault();
        ev.stopPropagation();
        let request = new dtos.NewAlert({
            accountId: shared.accountId,
            name: this.name,
            windowHours: this.windowHours,
            threshold: this.threshold,
            trigger: this.trigger,
            notificationEmailAddresses: this.notificationEmailAddresses,
            customerSelection:  this.customerSelection,
            customerIds: this.customerIds
        });
        let newAlert = await serviceClient.post(request);
        this.props.onCreated(newAlert);
        this.props.onClosed();
    }

    render() {
        let { visible, onClosed } = this.props;
        return (
            <ui.Modal visible={visible} title="New Alert" onCancel={onClosed} onOk={(ev) => this.save(ev)} bodyStyle={{paddingTop: 0}}>
                <ui.Tabs>
                    <ui.Tabs.TabPane tab="General" key="general">
                        <ui.Form layout="vertical" onSubmitCapture={(ev) => this.save(ev)}>
                            <ui.Form.Item label="Name">
                                <ui.Input value={this.name} onChange={v => this.name = v.target.value} />
                            </ui.Form.Item>
                            <ui.Form.Item label="Trigger">
                                <ui.Select value={this.trigger} onChange={v => this.trigger = v} style={{ width: 300 }}>
                                    {Object.keys(dtos.AlertTriggers).map(k => <ui.Select.Option value={k} key={k}>{splitIntoWords(k)}</ui.Select.Option>)}
                                </ui.Select>
                                <p><small>Alerts are triggered based the total for an individual customer, for example a trigger of Call Spend with Threshold 100 and Window 8 means that if any customer's call spend within the past 8 hours exceeds $100, the alert will be triggered for that customer.</small></p>
                            </ui.Form.Item>
                            <ui.Form.Item label="Threshold">
                                <ui.Input type="number" value={this.threshold} onChange={ev => this.threshold = parseFloat(ev.target.value) || 0} />
                                <p><small>The threshold determines the amount past which the alert is triggered. For example if the threshold is set to 100, a call spend of 100.01 within the window interval would trigger the alert</small></p>
                            </ui.Form.Item>
                            <ui.Form.Item label="Window (hours)">
                                <ui.Input type="number" value={this.windowHours} onChange={ev => this.windowHours = parseFloat(ev.target.value) || 0} />
                                <p><small>The window determines the time frame over which the alert is calculated. For example a window of 1.5 means within the past 1.5 hours</small></p>
                            </ui.Form.Item>
                        </ui.Form>
                    </ui.Tabs.TabPane>
                    <ui.Tabs.TabPane tab="Customers" key="customers">
                        <ui.Form layout="vertical" onSubmitCapture={(ev) => this.save(ev)}>
                            <ui.Form.Item label="Customer Selection" style={{ marginBottom: 0 }}>
                                <ui.Select value={this.customerSelection} onChange={ev => this.customerSelection = ev as dtos.AlertCustomerSelection}>
                                    <ui.Select.Option value="AllCustomers">(All Customers)</ui.Select.Option>
                                    <ui.Select.Option value="ExcludeCustomers">Exclude Specific Customers</ui.Select.Option>
                                    <ui.Select.Option value="IncludeCustomers">Include Specific Customers</ui.Select.Option>
                                </ui.Select>
                            </ui.Form.Item>
                            {(this.customerSelection === dtos.AlertCustomerSelection.ExcludeCustomers || this.customerSelection === dtos.AlertCustomerSelection.IncludeCustomers) && <div>
                                <CustomersList customerIds={this.customerIds} onChanged={ids => this.customerIds = ids} />
                                <p style={{ margin: 0 }}><small>To alert for all customers, select <strong>All Customers</strong></small></p>
                                <p style={{ margin: 0 }}><small>To alert for all customers except for certain customers, select <strong>Exclude Specific Customers</strong></small></p>
                                <p style={{ margin: 0 }}><small>To only alert for certain customers, select <strong>Include Specific Customers</strong></small></p>
                            </div>}
                        </ui.Form>
                    </ui.Tabs.TabPane>
                    <ui.Tabs.TabPane tab="Notifications" key="notifications">
                        <ui.Form.Item label="Notify Email Addresses (one per line)">
                            <ui.Input.TextArea value={this.notificationEmailAddresses} onChange={ev => this.notificationEmailAddresses = ev.target.value} placeholder="One per line" />
                            <p><small>Alerts are also saved to the system log and can be found by searching for the alert's name</small></p>
                        </ui.Form.Item>
                    </ui.Tabs.TabPane>
                </ui.Tabs>
            </ui.Modal>
        );
    }
}